import moment from "moment"
import styled from "styled-components"
import { showModal, showNestedModal } from "../../features/modal/modalSlice"
import { useDispatch } from "react-redux"
import { setSelectUserData } from "../../features/user/userSlice"
import { MdOutlineMoreHoriz } from "react-icons/md";
import { getRegularDriverDetails, setRegularDriverData } from "../../features/driversVehicles/driversVehiclesSlice"

const Container = styled.div`
    width: 100%;
    display: flex;
    border: 1px solid ${({theme}) => theme.mainBorderColor};
    border-radius: 20px;
    cursor: pointer;
    position: relative;

    &:hover{
        background-color: ${({theme}) => theme.secondaryBgColor};
    }

    .wrapper{
        width: 100%;
        display: flex;
        flex-direction: row !important;
        justify-content: space-between;
        padding: 20px;


        .column-item{
            color: ${({theme}) => theme.mainTextColor};
            display: flex;
            flex-direction: column;
            gap: 5px;
            width: 25%;

            h3{
                font-size: 15px;
                font-weight: 700;
                text-decoration: underline;
                padding-bottom: 5px;
            }

            .value{
                font-size: 14px;
                font-weight: var(--font-weight-md);
            }

            .red{
                color: var(--color-main);
                font-weight: 600;
            }
        }
    }

    .more-btn{
        position: absolute;
        top: 10px;
        right:10px;

        .more-icon{
            font-size: 1.4rem;
        }


    }

    
`


const SingleRegularDriverItem = ({item}) => {

    const dispatch = useDispatch()

  return (
    <Container onClick={() => {dispatch(setRegularDriverData(item)); dispatch(showModal("regularDriverItemDetails")); dispatch(getRegularDriverDetails(item?.phoneNumber))}}>
        <div className="wrapper">
            <div className="column-item">
                <h3>Sürücü</h3>
                <div className="value red"onClick={(e) => {e.stopPropagation(); dispatch(showNestedModal("surucuProfil")); dispatch(setSelectUserData(item?.phoneNumber)) }}>{item.firstLastName}</div>
                <div className="value">{item.phoneNumber}</div>
                <div className="value">{moment(item?.createdDate).format("lll", "tr")}</div>
            </div>

            <div className="column-item">
                <h3>Araç</h3>
                <div className="value">{item.vehicleCount} Araç</div>
            </div>

            <div className="column-item">
                <h3>Referans</h3>
                <div className="value">{item?.isContinueVehicle
                ? "Devamlı Aracım"
                : "Misafir Araç"}</div>
                <div className="value"> {item?.isReferenceDriver
                ? "Referansıyım"
                : "Referansı Değilim"}</div>
            </div>

            <div className="column-item">
                <h3>Üyelik ve Erişim İzni</h3>
                <div className="value info">
                    {item?.isKamyoonMember === false ||
                    item?.isKamyoonMember === null ? (
                    <span onClick={() => dispatch(showModal("DevamliAraclarDavetModal")) } className="invite">
                        Kamyoon'a Üye Değil
                    </span>
                    ) : (
                    "Kamyoon'a Üye"
                    )}
                </div>
                <div className="value info">
                    {item?.isKamyoonAccessPermission === false ||
                    item?.isKamyoonAccessPermission === null ? (
                    <span className="invite">Erişim İzni Yok</span>
                    ) : (
                    "Erişim İzni Var"
                    )}
                </div>
            </div>
        </div> 

        <button onClick={(e) => {e.stopPropagation(); dispatch(showModal("updateRegularDriverRefAndRegular")); dispatch(setRegularDriverData(item))}} className="more-btn"><MdOutlineMoreHoriz className="more-icon"/></button>
    </Container>
  )
}

export default SingleRegularDriverItem
